"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bindBankSms = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var cashLoanAuth_1 = require("../../model/cashLoanAuth");
var service_1 = require("../../../library/base/service");
var bindBankSms = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(bindBankSms, _super);
    function bindBankSms() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '授信绑定银行卡发送验证码接口';
        _this.code = '101134';
        _this.desc = '授信绑定银行卡发送验证码接口';
        _this.requestParams = new cashLoanAuth_1.bindBankSmsRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return bindBankSms;
}(service_1.BaseService));
exports.bindBankSms = bindBankSms;
//# sourceMappingURL=bindBankSms.js.map